import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a36d9934e39111a98af1ce12f2b5e0e1cb from "./generated-373c0c07-6801-472f-a26d-0599f00fd085.json";

import afc71832901e38142e6766e6d130bbaf8b from "./generated-69a1df55-65b7-4243-a912-22cc63c2a6a1.json";

import aa6f9b0adff145230e7ef9ecb19a416f5b from "./generated-e53b79fa-95e6-4dfb-9a1f-297b68ae1da5.json";

import a9462c7ee0def8f600562e9295e9207e7b from "./generated-0539b237-8933-4b87-8a09-964a34a06260.json";

import a01792c39ab94dcf6cb53929e5555eed0b from "./generated-e808ee97-103b-4339-b818-12d0d77118f6.json";

import a594527dc1f4d3810db48568bd4a82321b from "./generated-9c2740c3-dfab-4e06-bc01-3c078b0ec572.json";

import affb1fe92b53d9660f5a54ffb076610feb from "./generated-eaf63604-79be-4898-bf0b-f9b96a58cfef.json";

import a1a6909641837c97c7e27c3c222b84763b from "./generated-2a8e5f3c-45b5-4aae-932a-0eadfc24d050.json";

import a19bca78fc27e9e8b592a431987d4943ab from "./generated-ab220431-f7e5-452f-886b-c21cb03c7b97.json";

import a9bb6c6b84ddd23e1eb6e0781eda38149b from "./generated-f02623dd-15b9-4c2f-88f4-f6a0aa351254.json";

import a3cedfc1361945ea13f3b7b3165afc186b from "./generated-3a33e3be-de38-4f10-b78a-3ffd5cb362e6.json";

import a46287aa187ec1f2bbbe6225265a3c046b from "./generated-545a2927-9dac-4cf8-a612-77e5ed960f6d.json";

import a066c55b4d28117cdd9e75c7fbd6d164bb from "./generated-6958318d-3b6a-4f90-86ce-798085db5fae.json";

import a2cb6c36c3896c4d492fc952a3def555db from "./generated-d1f98c0b-d6cb-45be-9bb8-f4be4f370d0d.json";

import a866dcf00415d8073ae3035f17b01289cb from "./generated-41d98d31-520f-4e18-8760-8c3b470a6e59.json";

import aae82e423ef6e817a08d67296c7c80053b from "./generated-00600805-a9a0-4934-87bc-5b7d78cfe722.json";

import ae1ac1dbee77fc96ebdbf0a46e998e6f4b from "./generated-7fda87d4-8a8a-452e-8cdb-663d4392a4ed.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a36d9934e39111a98af1ce12f2b5e0e1cb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(afc71832901e38142e6766e6d130bbaf8b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aa6f9b0adff145230e7ef9ecb19a416f5b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a9462c7ee0def8f600562e9295e9207e7b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a01792c39ab94dcf6cb53929e5555eed0b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a594527dc1f4d3810db48568bd4a82321b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(affb1fe92b53d9660f5a54ffb076610feb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a1a6909641837c97c7e27c3c222b84763b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a19bca78fc27e9e8b592a431987d4943ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a9bb6c6b84ddd23e1eb6e0781eda38149b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a3cedfc1361945ea13f3b7b3165afc186b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a46287aa187ec1f2bbbe6225265a3c046b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a19bca78fc27e9e8b592a431987d4943ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a066c55b4d28117cdd9e75c7fbd6d164bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a2cb6c36c3896c4d492fc952a3def555db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a19bca78fc27e9e8b592a431987d4943ab);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a866dcf00415d8073ae3035f17b01289cb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aae82e423ef6e817a08d67296c7c80053b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ae1ac1dbee77fc96ebdbf0a46e998e6f4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a866dcf00415d8073ae3035f17b01289cb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */